<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card class="overflow-hidden flex justify-center items-center">
        <div slot="no-body">
          <router-link tag="div" class="cursor-pointer flex items-center justify-center" :to="`/${link}`">
            <div class="w-full items-center justify-between mt-2 mb-2">
              <center>
                <user-icon v-if="icon === 'UserIcon'" size="2x" class="custom-class"></user-icon>
                <tag-icon v-if="icon === 'TagIcon'" size="2x" class="custom-class"></tag-icon>
                <edit-icon v-if="icon === 'EditIcon'" size="2x" class="custom-class"></edit-icon>
              </center>
              <p class="w-full text-center">{{ title }}</p>
            </div>
          </router-link>
        </div>

    </vx-card>
</template>

<script>
import { EditIcon, TagIcon, UserIcon } from 'vue-feather-icons'

export default{
  props: {
    link: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      chartOptions: null
    }
  },
  methods: {
  },
  components: {
    EditIcon,
    TagIcon,
    UserIcon
  },
  created () {
  }
}
</script>
